import styles from "./SizeDropDown.module.scss";
import Select from "@JohnLewisPartnership/jl-design-system/dist/elements/select/Select";
import React from "react";
import { SizeError } from "./components/SizeError/SizeError";

export type SizeType = {
  name: string | null | undefined;
  sublabel?: string | null | undefined;
  sizeReductionLabel: string;
  showReduced: boolean;
  unavailable: boolean;
  isSelected: boolean;
}[];

type SizeDropDownProps = {
  uniqueSizes: SizeType;
  /**
   * A function that handles click events, taking a string value as an argument.
   */
  handleClick: (value: string) => void;
};

export const SizeDropDownUI = ({
  uniqueSizes: uniqueSizes,
  handleClick,
}: SizeDropDownProps) => {
  let currentSize = uniqueSizes.find((size) => size.isSelected)?.name || "";
  const [sizeValue, setSizeValue] = React.useState(currentSize);

  const OUT_OF_STOCK = " - Out of stock";

  if (uniqueSizes.length == 0) {
    return null;
  }
  const sizeOptions = uniqueSizes.map((size) => {
    const isOutOfStock = size.unavailable;
    const isSizeReducedToClear = size.showReduced;

    return {
      label: `${size.name} ${isOutOfStock ? OUT_OF_STOCK : ""} ${
        isSizeReducedToClear && !isOutOfStock
          ? `- ${size.sizeReductionLabel}`
          : ""
      }`,
      value: size.name,
    };
  });

  return (
    <>
      <SizeError
        sizes={uniqueSizes.map((size) => ({
          name: size.name,
        }))}
      ></SizeError>
      <div>
        <h2 id="select-size">
          <span
            aria-hidden="true"
            data-cy="size-heading"
            className={styles.size_text}
          >
            <strong
              data-cy="size-heading-text"
              className={styles["size_heading_text"]}
            >
              Size:&nbsp;
            </strong>
            {sizeValue ? (
              <p className={styles["size_value_text"]}>{sizeValue}</p>
            ) : (
              ""
            )}
          </span>
        </h2>
      </div>
      <Select
        id="select-size"
        name="select-size"
        data-testid="select-size"
        ariaLabel="Select the size"
        options={[{ label: "Select a size", value: "" }, ...sizeOptions]}
        onChange={(e: { target: HTMLSelectElement }) => {
          setSizeValue(e.target.value);
          handleClick(e.target.value);
          currentSize = e.target.value;
        }}
        value={sizeValue}
      ></Select>
    </>
  );
};
